<script setup lang="ts">
import { ROUTE_NAV } from '@/shared/config'

import { OnboardingButton } from '@/features/onboarding'

// const { $fbq } = useNuxtApp()
const router = useRouter()
const localePath = useLocalePath()

function onGoToOnboarding() {
  // $fbq('trackCustom', 'TestEvent', { test_event_code: 'TEST33158' })
  router.push(localePath(ROUTE_NAV.onboarding))
}

async function requestLogin() {
  console.log('requestLogin------1')
  const response = await $fetch('/api/fn/auth/login', {
    headers: { 'X-Require-Whisk-Auth': 'kjNavl@^@PZ6mozRj@frVLBASG2uo19t' },
  })
  console.log('requestLogin------2', response)
}
</script>

<template>
  <main>
    <div class="min-h-screen">
      <header class="bg-white">
        <div class="mx-auto flex justify-between px-16 py-16 md:container">
          <div>
            <img class="h-24" src="/index-page/logo.webp" alt="ufit.plus logo" />
          </div>
          <div></div>
          <div>
            <button @click="requestLogin">/fn/login</button>
          </div>
        </div>
      </header>
      <div
        class="overflow-hidden"
        style="
          background-image: linear-gradient(
            325deg,
            hsl(0deg 0% 77%) 0%,
            hsl(0deg 0% 79%) 21%,
            hsl(0deg 0% 81%) 30%,
            hsl(0deg 0% 83%) 39%,
            hsl(0deg 0% 85%) 46%,
            hsl(0deg 0% 87%) 54%,
            hsl(0deg 0% 88%) 61%,
            hsl(0deg 0% 90%) 69%,
            hsl(0deg 0% 92%) 79%,
            hsl(0deg 0% 94%) 100%
          );
        "
      >
        <div class="mx-auto flex min-h-[80vh] flex-col px-16 md:flex-row md:container">
          <div class="flex flex-1 flex-col items-center justify-center pt-64 md:items-start md:pt-0">
            <h1 class="text-h1-bold text-center mb-16">Твій онлайн-тренер</h1>
            <h2 class="text-h4-medium text-center lg:text-left mb-40">
              Займайся тілом сьогодні, щоб завтра воно допомагало тобі
            </h2>
            <OnboardingButton class="!rounded-4 !h-40 !w-auto px-32 mb-40" @click="onGoToOnboarding">
              Розпочати
            </OnboardingButton>
          </div>
          <div class="flex flex-1 items-end justify-start">
            <img
              class="mx-auto"
              width="550"
              height="550"
              src="/index-page/first-screen-x2.webp"
              alt=""
              color:transparent
            />
          </div>
        </div>
      </div>
      <div class="bg-white">
        <div class="mx-auto flex flex-col items-center px-16 py-32 md:container">
          <h2 class="text-center text-h3-semibold text-black mb-32">Ви отримаєте</h2>
          <div class="grid w-full max-w-[1150px] text-h4-semibold text-center gap-16 md:grid-cols-4">
            <div class="col-span-2 bg-gray-200 min-h-120 lg:min-h-auto flex justify-center items-center p-24">
              Індівідуальний план тренуван
            </div>
            <div
              class="row-span-2 bg-orange-200 min-h-120 lg:min-h-auto lg:h-320 flex justify-center items-center p-24"
            >
              Адаптація навантаження під прогрес
            </div>
            <div class="row-span-2 bg-gray-200 min-h-120 lg:min-h-auto flex justify-center items-center p-24">
              7-10 хв тривалість тренування
            </div>
            <div
              class="col-span-2 text-white bg-gray-800 min-h-120 lg:min-h-auto flex justify-center items-center p-24"
            >
              150+ видів вправ під тебе
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="h-32 bg-neutral-100"></div>
    <footer class="mb-16 bg-white md:mb-0">
      <div class="mx-auto md:container px-16 py-32">
        <div class="flex flex-col md:flex-row">
          <div class="flex flex-col md:flex-1">
            <a href="/">
              <img class="h-24" src="/index-page/logo.webp" alt="ufit.plus logo" />
            </a>
            <p class="py-12 text-sm font-normal text-neutral-500">
              Займайся фітнесом вдома з персональними тренуваннями від професійних тренерів. Досягай своїх фітнес-цілей
              з комфортом і впевненістю.
            </p>
            <div class="my-16 flex gap-8 justify-center md:justify-start">
              <a
                target="_blank"
                class="rounded-8 bg-neutral-200 p-8 text-neutral-600 transition hover:bg-neutral-300 hover:text-neutral-700"
                href="https://instagram.com/ufit.plus/"
              >
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  viewBox="0 0 16 16"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"
                  ></path>
                </svg>
              </a>
              <!-- <a
                target="_blank"
                class="rounded-8 bg-neutral-200 p-8 text-neutral-600 transition hover:bg-neutral-300 hover:text-neutral-700"
                href="https://twitter.com"
              >
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  viewBox="0 0 16 16"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z"
                  ></path>
                </svg>
              </a> -->
              <a
                target="_blank"
                class="rounded-8 bg-neutral-200 p-8 text-neutral-600 transition hover:bg-neutral-300 hover:text-neutral-700"
                href="https://facebook.com/ufit.plus/"
              >
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  viewBox="0 0 16 16"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"
                  ></path>
                </svg>
              </a>
              <!-- <a
                target="_blank"
                class="rounded-8 bg-neutral-200 p-8 text-neutral-600 transition hover:bg-neutral-300 hover:text-neutral-700"
                href="https://linkedin.com"
              >
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  viewBox="0 0 16 16"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"
                  ></path>
                </svg>
              </a> -->
            </div>
          </div>
          <!-- <div class="mt-5 flex justify-between md:mt-0 md:flex-[2] md:justify-around">
            <div class="flex flex-col">
              <strong class="mb-5 text-sm font-bold text-neutral-600 md:text-base">Company</strong>
              <ul class="flex flex-col gap-2 text-xs font-normal text-neutral-500 md:text-sm">
                <a class="transition hover:text-neutral-700" href="/about">About</a
                ><a class="transition hover:text-neutral-700" href="/term-of-use">Term of Use</a
                ><a class="transition hover:text-neutral-700" href="/privacy-policy">Privacy Policy</a
                ><a class="transition hover:text-neutral-700" href="/how-works">How it Works</a
                ><a class="transition hover:text-neutral-700" href="/contact-us">Contact Us</a>
              </ul>
            </div>
            <div class="flex flex-col">
              <strong class="mb-5 text-sm font-bold text-neutral-600 md:text-base">Support</strong>
              <ul class="flex flex-col gap-2 text-xs font-normal text-neutral-500 md:text-sm">
                <a class="transition hover:text-neutral-700" href="/support">Support Career</a
                ><a class="transition hover:text-neutral-700" href="/24-service">24h Service</a
                ><a class="transition hover:text-neutral-700" href="/quick-chat">Quick Chat</a>
              </ul>
            </div>
            <div class="flex flex-col">
              <strong class="mb-5 text-sm font-bold text-neutral-600 md:text-base">Contact</strong>
              <ul class="flex flex-col gap-2 text-xs font-normal text-neutral-500 md:text-sm">
                <a class="transition hover:text-neutral-700" href="/whatsapp">Whatsapp</a
                ><a class="transition hover:text-neutral-700" href="/24-service">Support 24</a>
              </ul>
            </div>
          </div> -->
        </div>
      </div>
      <div class="bg-neutral-100">
        <div class="mx-auto md:container px-16 py-12">
          <div
            class="flex flex-col items-center justify-between gap-8 text-xs font-medium text-neutral-700 md:flex-row"
          >
            <p>Copyright © 2024 Ufit.plus</p>
            <p>All Right Reserved</p>
          </div>
        </div>
      </div>
    </footer>
  </main>
</template>

<style scoped></style>
